import {IMessage} from "niteroi/packages/customer-services/models/interfaces";

class Formatter {
    public lastMessageFrom(messages: Array<IMessage>) {
        if (!Array.isArray(messages) || messages.length === 0) {
            return "";
        }
        return messages[messages.length - 1].messageFrom;
    }
}

const formatter = new Formatter();
export default formatter;
